<template>
  <deleted-page-component>
    <div class="content-container">
    <p class="mb-30">{{userName ? userName : 'User'}} is not avaliable anymore. Hit the button below to change your expert or continue journey with {{dealerName ? dealerName : 'dealer'}}</p>
    <div class="buttons">
       <f7-link :href="newExpertUrl" no-link-class external class="button-primary">Select your new Expert</f7-link>
       <f7-link :href="websiteUrl" no-link-class external class="button-simple">Go to {{dealerName ? dealerName : "dealer's"}} website</f7-link>
    </div>
    </div>
  </deleted-page-component>
</template>

<script>
import { mapGetters } from 'vuex'
import DeletedPage from './deleted-common.vue'
export default {
  components: {
    'deleted-page-component': DeletedPage
  },
  computed: {
    ...mapGetters({
      deletedInfo: 'common/deletedInfo'
    }),
    userName () {
      return this.deletedInfo ? this.deletedInfo.salesPersonFullName : null
    },
    dealerName () {
      return this.deletedInfo ? this.deletedInfo.companyName : null
    },
    newExpertUrl () {
      return this.deletedInfo ? this.deletedInfo.widgetChooseSalesPersonPageUrl : null
    },
    websiteUrl () {
      return this.deletedInfo ? this.deletedInfo.widgetWelcomePageUrl : null
    }
  }
}
</script>

<style scoped>
.content-container{
    width: 100%;
}

.content-container > *{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 30px;
}

p {
    font-weight: 700;
    font-size: 22px;
    line-height: 28px;
    margin: 0;
}

.buttons {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.buttons > a:hover{
  cursor: pointer;
}

.buttons > a:first-child{
    margin-bottom: 30px;
}

.button-simple, 
.button-primary{
    display: inline-block;
    font-size: 24px;
    font-weight: 700;
    padding: 21px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
}

.button-simple{
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
}

.button-primary{
    color: #2C61D5;
    background-color: #FFFFFF;
}

</style>



// WEBPACK FOOTER //
// deleted-salesperson.vue?3caa346d